import { Card, CardList } from "components/Card";
import DataTable, { parseSortParam } from "components/DataTable";
import Form from "components/Form";
import Page from "components/Page";
import ProjectFilter, { FilterOptions } from "containers/ProjectFilter";
import { FetchAllStoresOrFilesQueryOptions } from "interfaces/filterQuery";
import { ProjectType } from "interfaces/project";
import { Store } from "interfaces/store";
import isEmpty from "lodash/isEmpty";
import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Column } from "react-table-latest";
import { State } from "state";
import { setItem, removeItem, getItemJson } from "helpers/storage";
import { createAnalyticsEvent, EventTypes, SearchFields } from "state/analytics";
import { fetchUserStores } from "state/stores";
import { allFieldsEmpty } from "utils/helpers";
import { PaginatedQuery } from "interfaces/paginated-query";
import { getPillProps, Pill } from "components/Pill";
import Dropdown from "components/Dropdown";
import Constants from "helpers/constants";
import moment from "moment-timezone";
import { FormHeader, InputField } from "./DirDownloads";
import { LightThemeTable } from "components/LightThemeTable";

// only load the America/Chicago timezone
moment.tz.load({
  version: "2018g",
  zones: [
    "America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
  ],
  links: ["America/Chicago|US/Central"],
});

type MyStoresProps = RouteComponentProps<{}> & PropsFromRedux;

interface MyStoresState {
  currentName: string;
  currentType: string;
  query: typeof defaultQuery;
  fields: Set<string>;
  isStoresSearchInProgress?: boolean;
}

export const MY_STORES_PAGE_SIZE = 100;
export const MY_STORES_DEFAULT_SORT = "actual_reset_date.desc";

const defaultPaginationParams: PaginatedQuery = {
  sort: MY_STORES_DEFAULT_SORT,
  size: MY_STORES_PAGE_SIZE,
  page: 0,
};

const defaultQuery: FetchAllStoresOrFilesQueryOptions & PaginatedQuery = {
  storeName: "",
  storeNumber: "",
  address: "",
  city: "",
  state: "",
  zip: "",
  abWholesaler: "",
  millerWholesaler: "",
  coorsWholesaler: "",
  thirdPartyWholesaler: "",
  advertisingZone: "",
  cluster: "",
  projectId: "",
  status: "",
  ...defaultPaginationParams,
};

const defaultState: MyStoresState = {
  currentName: "",
  currentType: "",
  fields: new Set(),
  query: defaultQuery,
  isStoresSearchInProgress: false,
};


const statusArray = [
  "Store Status",
  // Constants.RESET_NOT_SCHEDULED,
  Constants.RESET_SCHEDULED,
  Constants.RESET_COMPLETE,
  Constants.NEEDS_VALIDATION,
  // Constants.VALIDATION_PENDING,
  // Constants.FEEDBACK_UNDER_REVIEW,
  // Constants.NEEDS_FEEDBACK_REVIEW,
  // Constants.AWAITING_FINAL_UPLOAD,
  Constants.FILES_AVAILABLE,
  Constants.VALIDATION_COMPLETE,
];

const userDropdownOptions = statusArray.map((arrVal, i) => ({
  label: arrVal,
  value: i === 0 ? "" : arrVal,
  "data-qa": arrVal,
}));

const ProjectFilterV2: React.FC<{
  value?: number;
  onChange: (option: FilterOptions) => any;
}> = ({ value, onChange }) => (
  <div style={styles.inputGroup}>
    <div style={styles.inputLabel}>
      Project
    </div>
    <div
      data-qa="select-project"
      style={{ height: 0, border: "0px solid #ddd", borderRadius: 6, boxSizing: "border-box" }}
    >
             <ProjectFilter
                    onChange={onChange}
                    value={value}
                    minHeight={44}
                  />
    </div>
  </div>
);

class MyStores extends React.Component<MyStoresProps, MyStoresState> {
  private initialStores = [];
  private submitted = false;

  public state = defaultState;

  public componentDidMount() {
    const query = getItemJson(Constants.MY_STORES_QUERY);
    if (query) {
      this.setState({
        query: {
          ...query,
        }
      });
      this.submitted = true;
      this.setMyStores(query);
    }
  }
  componentDidUpdate(_prevProps: MyStoresProps, prevState: MyStoresState) {
    const { page: prevPage, size: prevSize, sort: prevSort } = prevState.query;
    const { page: currPage, size: currSize, sort: currSort } = this.state.query;
    const isSortOrPageChanged =
      !this.state.isStoresSearchInProgress &&
      (prevPage !== currPage || prevSize !== currSize || prevSort !== currSort);

    if (isSortOrPageChanged) {
      this.props.fetchUserStores(this.state.query);
    }
  }

  public handleClear = (e: React.MouseEvent<HTMLButtonElement>) => {
    const { page, size, sort } = this.state.query;
    removeItem(Constants.MY_STORES_QUERY);
    this.setState({
      currentName: "",
      currentType: "",
      query: {
        ...defaultQuery,
        // Ensure clearing filters leaves pagination params intact
        page,
        size,
        sort,
      },
      fields: new Set(),
    });

    this.props.createAnalyticsEvent({
      event: EventTypes.MY_STORES_SEARCH,
      eventType: "Action",
      searchAction: "Clear",
    });
  };

  public setMyStores(query: FetchAllStoresOrFilesQueryOptions) {
    query = {
      ...query,
      ...defaultPaginationParams,
    };

    this.setState({
      query,
      isStoresSearchInProgress: true,
    });

    const { currentName, currentType, fields } = this.state;

    this.props.fetchUserStores(query).then((payload) => {
      const stores = payload?.data ?? [];

      this.setState({
        isStoresSearchInProgress: false,
      });

      if (currentName && currentType) {
        this.props.createAnalyticsEvent({
          event: EventTypes.MY_STORES_SEARCH,
          eventType: "Action",
          projectName: currentName,
          projectType: currentType as ProjectType,
          searchResults: stores.length,
          searchFieldsList: Array.from(fields) as SearchFields[],
          searchAction: "Search",
        });
      } else {
        this.props.createAnalyticsEvent({
          event: EventTypes.MY_STORES_SEARCH,
          eventType: "Action",
          searchResults: stores.length,
          searchFieldsList: Array.from(fields) as SearchFields[],
          searchAction: "Search",
        });
      }
    });
  }
  public handleSubmit = (e: React.MouseEvent<HTMLFormElement>) => {
    e.preventDefault();
    this.submitted = true;
    setItem(Constants.MY_STORES_QUERY, this.state.query);
    this.setMyStores(this.state.query);
  };

  public concatRowId(row: any) {
    return String(row.id + "_" + row.project_id + "_" + row.type_id);
  }

  public handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      query: {
        ...this.state.query,
        [e.currentTarget.name]: e.currentTarget.value,
      },
      fields: this.state.fields.add(e.currentTarget.placeholder),
    });
  };

  public handleChangeStatus = (newValue: string) => {
    this.setState({
      query: {
        ...this.state.query,
        status: newValue,
      },
      fields: this.state.fields.add("Status"),
    });
  };

  public renderForm(stores: any, tableColumnsConfig: any, _isLoading?: boolean) {
    const { page, sort, size, ...filters } = this.state.query;
    const clearDisabled = isEmpty(filters) || allFieldsEmpty(filters);

    const colorPicker: string =
      this.state.query.status && this.state.query.status !== "Store Status" ? "#4a4a4a" : "#acacac";


    return (   
      <div
      style={{
        gap: 0,
        borderRadius: "16px",
        padding: "5px",
        backgroundColor: "#fff",
        boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
      }}
    >
      <Card style={styles.container}>
        <Form onSubmit={this.handleSubmit} style={{ width: "100%" }}>
          <FormHeader headerText="Search Stores" isSubmitDisabled={false} />

          <div style={styles.inputRow}>

            <ProjectFilterV2
                    onChange={({ id, name, type }: FilterOptions) => {
                      this.setState({
                        currentName: name,
                        currentType: type,
                        query: {
                          ...this.state.query,
                          projectId: id > 0 ? id : "",
                        },
                      });
                    }}
                    value={Number(this.state.query.projectId) || -1}
                  />

                <InputField
            placeholder="Store Number"
            label="Store Number"
            name="storeNumber"
            value={this.state.query.storeNumber}
            onChange={this.handleChange}
            data-qa="store-number-field"
          />
          <InputField
            placeholder="Store Number"
            label="Store Number"
            data-qa="store-name-field"
            value={this.state.query.storeName}
            name="storeName"
            onChange={this.handleChange}
          />

          </div>
            
          <div style={styles.inputRow}>
            <InputField
            label="Address"
            placeholder="Address"
            data-qa="address-field"
            value={this.state.query.address}
            name="address"
            onChange={this.handleChange}
          />
             <InputField
            label="City"
            placeholder="City"
            data-qa="city-field"
            value={this.state.query.city}
            name="city"
            onChange={this.handleChange}
          />
          <InputField
            label="State"
            placeholder="State"
            data-qa="state-field"
            value={this.state.query.state}
            name="state"
            onChange={this.handleChange}
          />
          <InputField
            label="Zip Code"
            placeholder="Zip Code"
            data-qa="zip-code-field"
            value={this.state.query.zip}
            name="zip"
            onChange={this.handleChange}
          />
          </div>

          <div style={styles.inputRow}>
            <InputField
            label="AB InBev Wholesaler"
            placeholder="AB InBev Wholesaler"
            data-qa="ab-inbev-wholesaler-field"
            value={this.state.query.abWholesaler}
            name="abWholesaler"
            onChange={this.handleChange}
          />
             <InputField
            label="Miller Wholesaler"
            placeholder="Miller Wholesaler"
            data-qa="miller-wholesaler-field"
            value={this.state.query.millerWholesaler}
            name="millerWholesaler"
            onChange={this.handleChange}
          />
          <InputField
            label="Coors Wholesaler"
            placeholder="Coors Wholesaler"
            data-qa="coors-wholesaler-field"
            value={this.state.query.coorsWholesaler}
            name="coorsWholesaler"
            onChange={this.handleChange}
          />
          <InputField
            label="3rd Party Wholesaler"
            placeholder="3rd Party Wholesaler"
            data-qa="3rd-party-wholesaler-field"
            value={this.state.query.thirdPartyWholesaler}
            name="thirdPartyWholesaler"
            onChange={this.handleChange}
          />
          </div>

          <div style={styles.inputRow}>
            <InputField
            label="AdZone"
            placeholder="AdZone"
            data-qa="adzone-field"
            value={this.state.query.advertisingZone}
            name="advertisingZone"
            onChange={this.handleChange}
          />
             <InputField
            label="Cluster/Store Group"
            placeholder="Cluster/Store Group"
            data-qa="group-field"
            value={this.state.query.cluster}
            name="cluster"
            onChange={this.handleChange}
          />
          <div style={styles.inputGroup}>
    <div style={styles.inputLabel}>
      Survey
    </div>
              <div
      data-qa="select-project"
      style={{ height: 44, border: "0px solid #ddd", borderRadius: 6, boxSizing: "border-box" }}
    >
             <Dropdown
              value={this.state.query.status}
              options={userDropdownOptions}
              // Couldnt figure out how to update the value without using this placeholder equation, would like to change if we can figure out a better way
              placeholder={this.state.query.status ? this.state.query.status : "Store Status"}
              isDisabled={false}
              containerStyles={{
                     marginLeft: "unset",
                     background: "white",
                     boxShadow: 'none',
                     minWidth: 230,
                    }}
                    controlStyles={{
                    minHeight: 44,
                    borderRadius: "16px",
                  // border: "none"
                    }}
              placeholderStyles={{
                color: colorPicker,
              }}
              onChange={(status) => {
                this.handleChangeStatus(status.value);
              }}
              isSearchable
            />
          </div>
          </div>
          </div>
          
           <div style={styles.inputRow}>
            <button
      data-qa="submit-announcement"
      disabled={false}
      onClick={this.handleClear}
      type="submit"
      style={{
        ...styles.sendButton,
        opacity: false ? 0.6 : 1,
        cursor: false ? "not-allowed" : "pointer",
        backgroundColor: "white",
        color: "#E5B611",
        border: "solid",
        borderColor: "#E5B611"
      }}
    >
      Clear
    </button>

    <button
      data-qa="submit-announcement"
      disabled={false}
      onClick={() => this.handleSubmit}
      type="submit"
      style={{
        ...styles.sendButton,
        opacity: false ? 0.6 : 1,
        cursor: false ? "not-allowed" : "pointer",
        backgroundColor: "#E5B611",
      }}
    >
      Search
    </button>
           </div>
            <div style={styles.tableContainer}>
              <div style={{display: 'flex'}}>
                <div style={styles.inputLabel}>
      {'Results'}
    </div>
    
              </div>
              <LightThemeTable
                       data={stores} columns={tableColumnsConfig}
                       pageSizeOptions={[2, 5, 10, 100, 200]}/>
              </div>
        </Form>                    
      </Card>
    </div>
    );
  }

  public render() {
    const { history, isLoadingStores, storesPageCount, storesPageIndex } = this.props;

    const {
      isStoresSearchInProgress,
      query: { sort: storesSort },
    } = this.state;

    let stores: Store[] = this.initialStores;
    // Prevent using previously fetched stores in Redux from other pages.
    // The user must submit the search form at least once.
    if (this.submitted) {
      stores = this.props.stores;
    }

    const shouldResetTable = isStoresSearchInProgress && storesPageIndex === 0 && stores.length > 0;

    const tableColumnsConfig = [
  {
    field: "retail_store_num",
    header: "No.",
    formatter: (_: any, row: any) => {
    return (
      <div onClick={() => {handleRowClick(row)}}>
      {row.retail_store_num}
      </div>
    );
    },
  },
  {
    field: "name",
    header: "Name",
    formatter: (_: any, row: any) => {
    return (
      <div onClick={() => {handleRowClick(row)}}>
      {row.name}
      </div>
    );
    },
  },
  {
    field: "store_address",
    header: "Address",
    formatter: (_: any, row: any) => {
    return (
      <div onClick={() => {handleRowClick(row)}}>
      {row.store_address}
      </div>
    );
    },
  },
  {
    field: "chain_name",
    header: "Chain",
    formatter: (_: any, row: any) => {
    return (
      <div onClick={() => {handleRowClick(row)}}>
      {row.chain_name}
      </div>
    );
    },
  },
  {
    field: "project_name",
    header: "Project",
    formatter: (_: any, row: any) => {
    return (
      <div onClick={() => {handleRowClick(row)}}>
      {row.project_name}
      </div>
    );
    },
  },
  {
    field: "store_status",
    header: "Status",
    formatter: (_: any, row: any) => {
      let projectType = row.type_id === 1 ? Constants.VALIDATION : Constants.FILE_SHARING;
      const pill = getPillProps(row.store_status, projectType);
      return (
      <div onClick={() => {handleRowClick(row)}}>
       <Pill {...pill} />
      </div>
    );
    },
  },
  {
    field: "actual_reset_date",
    header: "Actual Reset",
    formatter: (_: any, row: any) => {
      return (
      <div onClick={() => {handleRowClick(row)}}>
       {row.actual_reset_date ? moment(row.actual_reset_date).tz("America/Chicago").format("M/DD/YYYY") : ""}
      </div>
    );
    },
  },
];

    const handleRowClick = (row: any) => {
  if (row.project_id && row.id) {
                        history.push(`/projects/${row.project_id}/stores/${row.id}`);
                      }
}

    return (    
      this.renderForm(stores, tableColumnsConfig, isLoadingStores)
    );
  }
}

const connecter = connect(
  (state: State) => ({
    stores: state.stores.content?.data,
    storesPageCount: state.stores.content?.pageCount,
    storesPageIndex: state.stores.content?.pageIndex,
    isLoadingStores: state.stores.loading,
  }),
  { fetchUserStores, createAnalyticsEvent }
);

type PropsFromRedux = ConnectedProps<typeof connecter>;

export default withRouter(connecter(MyStores));

const styles = {
  container: {
    backgroundColor: "#fff",
    padding: 20,
    borderRadius: 16,
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    width: "100%",
    boxSizing: "border-box" as const,
  },
   tableContainer: {
    backgroundColor: "#fff",
    padding: 20,
    borderRadius: 16,
    boxShadow: "0 0 0 1px rgba(0,0,0,0.1)",
    width: "100%",
    boxSizing: "border-box" as const,
  },
  tableHeader: { 
   fontSize: 14, color: "#333", fontWeight: 400, marginBottom: 8
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20,
  },
  title: { fontSize: 24, fontWeight: "normal" as const, color: "#333", margin: 0 },
  sendButton: {
    backgroundColor: "#E5B611",
    color: "#000000",
    border: "none",
    padding: "0px 12px",
    borderRadius: 8,
    cursor: "pointer",
    fontSize: 16,
    fontWeight: 400,
    height: '30px',
    width: '94px',
  },
  inputRow: { display: "flex", gap: 20, marginBottom: 20 },
  inputGroup: { display: "flex", flexDirection: "column" as const, flex: 1 },
  inputLabel: { fontSize: 14, color: "#333", fontWeight: 400, marginBottom: 8 },
  blankLabel: { fontSize: 14, color: "#333", fontWeight: 400, marginBottom: 8, marginTop: 24 },
  textInput: {
    padding: "12px 15px",
    border: "1px solid #ddd",
    borderRadius: 16,
    fontSize: 14,
    backgroundColor: "#fff",
    height: 44,
    boxSizing: "border-box" as const,
    width: "100%",
  },
} as const;
